import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, forwardRef, useCallback } from "react";
import { mergeProps } from "react-aria";
import { useTextBasedInput } from "../hooks/useTextBasedInput.js";
import { useComponentClassName } from "../../../auxiliary/useComponentClassName.js";
import { toViewClass } from "../../../utils/toViewClass.js";
const NumberInput = memo(
  forwardRef(({
    className,
    defaultValue,
    max,
    min,
    onChange,
    value,
    withTopToolbar,
    ...outerProps
  }, forwardedRed) => {
    const props = useTextBasedInput({
      ...outerProps,
      className: classNames(
        useComponentClassName("text-input"),
        useComponentClassName("number-input"),
        toViewClass("withTopToolbar", withTopToolbar),
        className
      ),
      defaultValue: defaultValue?.toString(10),
      max: max?.toString(10),
      min: min?.toString(10),
      onChange: useCallback((value2) => {
        value2 = typeof value2 === "string" && value2.trim() !== "" ? value2.replace(/[^\d]/g, "").replace(/^0*(?=\d)/, "") : null;
        onChange?.(value2 ? parseInt(value2) : null);
      }, [onChange]),
      value: value?.toString(10)
    }, forwardedRed);
    return /* @__PURE__ */ jsx(
      "input",
      {
        ...mergeProps(props, {
          onKeyDown: useCallback((event) => {
            if (event.code === "Period" || event.code === "Comma") {
              event.preventDefault();
            }
          }, [])
        }),
        type: "number"
      }
    );
  })
);
NumberInput.displayName = "NumberInput";
export {
  NumberInput
};
//# sourceMappingURL=NumberInput.js.map
